import appSettings from 'wanderu-config';

import ApiService from './apiService/apiService';

const GET_DEFAULT_OPTIONS = {
    withAuth: true,
    authViaHeader: true,
};

const POST_DEFAULT_OPTIONS = {
    withAuth: true,
    authViaHeader: true,
    contentType: 'application/json',
};

function removeLeadingSlashes(path) {
    return path.replace(/^\/+/, '');
}

function addTrailingSlash(rawPath) {
    let [path, query] = rawPath.split('?');

    if (path.charAt(path.length - 1) !== '/') {
        path += '/';
    }

    return `${path}${query
        ? '?' + query
        : ''}`;
}

function formatPath(path) {
    return removeLeadingSlashes(addTrailingSlash(path));
}

function buildUrl(path) {
    return appSettings.config.tix.urlRoot + formatPath(path);
}

async function get(path, init, options) {
    return ApiService.get(
        buildUrl(path),
        init,
        {
            ...GET_DEFAULT_OPTIONS,
            ...options,
        },
    );
}

async function post(path, init, options) {
    return ApiService.post(
        buildUrl(path),
        init,
        {
            ...POST_DEFAULT_OPTIONS,
            ...options,
        },
    );
}

export default {
    get,
    post,
};
